
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCoastalNavigation as ObiCoastalNavigationElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-coastal-navigation.js';
 
 
 

 
 export const ObiCoastalNavigation = createComponent({
   react: React,
   tagName: 'obi-coastal-navigation',
   elementClass: ObiCoastalNavigationElement,
   events: {
     
   }
  });
 
 